export const authConfig = {
  "credentials": {
    "secret": ""
  }
};


/*export const authConfig = {
  "realm": "ADFS-PROD-DIR-OIDC",
  "url": "https://sso-ocp1-gc.snam.it/auth/",
  "ssl-required": "none",
  "clientId": "0333ebad",
  "confidential-port": 0,
  "timeUpdateTokenBeforeExpires": "590000",
  "redirectUri": "https://edith-d.snam.it/",
  "credentials": {
    "secret": "7eec2eb0c02b5582a6c09786ad8794fd"
  }
};*/
/*
export const authConfig = {
  "realm": "ADFS-PROD-DIR-OIDC",
  "url": "https://sso-ocp1-gc.snam.it/auth/",
  "ssl-required": "none",
  "clientId": "0333ebad",
  "confidential-port": 0,
  "timeUpdateTokenBeforeExpires": "590000",
  "redirectUri": "",
  "credentials": {
    "secret": "7eec2eb0c02b5582a6c09786ad8794fd"
  }
}
*/
/*export const authConfig =
{
  "realm": "Edith",
  "url": "http://localhost:9090/auth/",
  "clientId": "edithFe",
  "redirectUri": "",
}*/
